var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlibaba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e7e7e7",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alibabacloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.995 17.077h-9.991v-2.254h9.991zM26.002 6.649h-6.612l1.596 2.258 4.82 1.477c0.851 0.276 1.456 1.061 1.456 1.988 0 0.004 0 0.009-0 0.013v-0.001 7.23c0 0.004 0 0.008 0 0.012 0 0.927-0.605 1.712-1.441 1.983l-0.015 0.004-4.82 1.478-1.596 2.258h6.612c2.758 0 4.994-2.236 4.994-4.994v0-8.715c0-2.758-2.236-4.994-4.994-4.994v0zM5.998 6.649h6.612l-1.596 2.258-4.82 1.477c-0.851 0.275-1.456 1.061-1.456 1.987 0 0.005 0 0.009 0 0.014v-0.001 7.23c-0 0.004-0 0.008-0 0.012 0 0.927 0.605 1.712 1.441 1.983l0.015 0.004 4.82 1.478 1.596 2.258h-6.612c-2.758 0-4.994-2.236-4.994-4.993v0-8.715c0-2.758 2.236-4.994 4.994-4.994v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlibaba);
export default __webpack_public_path__ + "static/media/Alibaba.6c5cd6ef7d530cf5d4b308494a40333d.svg";
export { ForwardRef as ReactComponent };